import { useCallback } from "react";
import { Close } from "@mui/icons-material";
import { Box, Dialog, Grid, IconButton, Paper, ButtonProps } from "@mui/material";
import Draggable from 'react-draggable';

interface DialogButtonProps {
    buttonContent: JSX.Element,
    children: any
    open: boolean
    setOpen: (open: boolean) => void
    onClose?: () => void
    onOpen?: () => void
}

export default function DialogButton(props: DialogButtonProps & ButtonProps) {

    const handleClickOpen = () => {
        props.onOpen?.()
        props.setOpen(true);
    };

    const handleClose = () => {
        props.onClose?.()
        props.setOpen(false);
    };

   const PaperComponent = useCallback((paperProps: any) => (
    <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiTableCell-root"], [class*="MuiDialogContent-root"], [class*="MuiAutocomplete-root"], [class*="MuiSelect-root"], [class*="MuiInputBase-root"], [class*="MuiButtonBase-root"], [class*="MuiFormControl-root"]'}    >
        <Paper {...paperProps} />
    </Draggable>
), []);

    return (
        <>
            <IconButton sx={{ paddingTop: 0, paddingBottom: 0 }} {...props} onClick={handleClickOpen}>
                {props.buttonContent}
            </IconButton>
            <Dialog
                open={props.open}
                onClose={handleClose}
                fullWidth
                maxWidth="lg"
                PaperComponent={PaperComponent}
            >
               <Grid container>
            <Grid item xs={1}>
                <IconButton onClick={handleClose}><Close /></IconButton>
            </Grid>
            <Grid
                item
                xs={11}
                id="draggable-dialog-title"
            
            >
                <Box padding={2}>{props.children}</Box>
            </Grid>
        </Grid>
            </Dialog>
        </>
    )
}